/* Saintfuel 10,000 — Theme JavaScript
   Mobile-first. Powered for Eternity(tm).
   ============================================================ */
'use strict';

// ── Mobile Nav Toggle ──────────────────────────────────────────────────────
(function () {
  var burger   = document.getElementById('sf-burger');
  var overlay  = document.getElementById('sf-nav-overlay');
  var backdrop = document.getElementById('sf-nav-backdrop');
  var closeBtn = document.getElementById('sf-nav-close');
  var body     = document.body;

  if (!burger || !overlay) return;

  function openNav() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    if (backdrop) {
      backdrop.classList.add('is-open');
      backdrop.setAttribute('aria-hidden', 'false');
    }
    burger.setAttribute('aria-expanded', 'true');
    body.style.overflow = 'hidden';
  }

  function closeNav() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    if (backdrop) {
      backdrop.classList.remove('is-open');
      backdrop.setAttribute('aria-hidden', 'true');
    }
    burger.setAttribute('aria-expanded', 'false');
    body.style.overflow = '';
  }

  burger.addEventListener('click', function () {
    if (overlay.classList.contains('is-open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', closeNav);
  }

  // Close on backdrop tap
  if (backdrop) {
    backdrop.addEventListener('click', closeNav);
  }

  // Close on Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) {
      closeNav();
    }
  });
})();

// ── Newsletter AJAX ────────────────────────────────────────────────────────
(function () {
  var forms = document.querySelectorAll('.sf-newsletter-form');

  forms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var successEl = form.parentElement.querySelector('.ms-news__success');
      var data = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: data
      })
        .then(function (res) {
          if (res.ok || res.status === 200 || res.redirected) {
            form.style.display = 'none';
            if (successEl) {
              successEl.style.display = 'block';
            }
          } else {
            return res.text().then(function (text) {
              // If Shopify redirects (non-AJAX scenario), still hide form
              form.style.display = 'none';
              if (successEl) successEl.style.display = 'block';
            });
          }
        })
        .catch(function () {
          // Fallback: show success optimistically
          form.style.display = 'none';
          if (successEl) successEl.style.display = 'block';
        });
    });
  });
})();

// ── Scroll-Triggered Animations ───────────────────────────────────────────
// Sections marked with .sf-anim-section get .is-in when ~15% visible.
// Hero (.shop-hero) fires immediately on DOMContentLoaded — no scroll needed.
(function () {
  // Hero plays on load
  function revealHero() {
    var hero = document.querySelector('.shop-hero');
    if (hero) hero.classList.add('is-in');
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealHero);
  } else {
    revealHero();
  }

  var sections = document.querySelectorAll('.sf-anim-section');
  if (!sections.length) return;

  // Fallback for browsers without IntersectionObserver — just reveal everything.
  if (!('IntersectionObserver' in window)) {
    sections.forEach(function (s) { s.classList.add('is-in'); });
    return;
  }

  function reveal(io, entry) {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    }
  }

  // Default trigger — fires when ~15% of the section is on screen
  var ioDefault = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { reveal(ioDefault, e); });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

  // Early trigger — fires as the section starts entering the viewport.
  // Opt-in via data-anim-trigger="early" on the section root.
  var ioEarly = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { reveal(ioEarly, e); });
  }, { threshold: 0, rootMargin: '0px 0px 12% 0px' });

  sections.forEach(function (s) {
    if (s.dataset.animTrigger === 'early') {
      ioEarly.observe(s);
    } else {
      ioDefault.observe(s);
    }
  });
})();

// ── Prayer-List Accordion ─────────────────────────────────────────────────
// Single-open: clicking a closed item opens it and closes the rest;
// clicking the currently open item collapses it.
(function () {
  document.querySelectorAll('.pr-list__items').forEach(function (list) {
    var items = Array.prototype.slice.call(list.querySelectorAll('.pr-list__item'));
    if (!items.length) return;

    items.forEach(function (item) {
      var toggle = item.querySelector('.pr-list__item-toggle');
      var panel  = item.querySelector('.pr-list__item-panel');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function () {
        var willOpen = !item.classList.contains('is-open');

        items.forEach(function (other) {
          other.classList.remove('is-open');
          var t = other.querySelector('.pr-list__item-toggle');
          var p = other.querySelector('.pr-list__item-panel');
          if (t) t.setAttribute('aria-expanded', 'false');
          if (p) p.setAttribute('aria-hidden', 'true');
        });

        if (willOpen) {
          item.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          panel.removeAttribute('aria-hidden');
        }
      });
    });
  });
})();

// ── Prayer Two-Level Accordion ────────────────────────────────────────────
// Categories: opening one auto-opens all its child prayers (so the whole
// section is ready to read in one tap). Closing closes them all back down.
// Sibling categories stay independent — open multiple at once.
// Prayers: individual toggles still work for collapsing one inside an open
// category.
(function () {
  function setItemState(item, toggle, panel, open) {
    item.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) {
      if (open) panel.removeAttribute('aria-hidden');
      else panel.setAttribute('aria-hidden', 'true');
    }
  }

  // Category toggles — cascade to child prayers
  document.querySelectorAll('.pr-acc__cat-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var cat = toggle.closest('.pr-acc__cat');
      if (!cat) return;
      var catPanel = document.getElementById(toggle.getAttribute('aria-controls'));
      var willOpen = !cat.classList.contains('is-open');

      setItemState(cat, toggle, catPanel, willOpen);

      cat.querySelectorAll('.pr-acc__prayer').forEach(function (prayer) {
        var pToggle = prayer.querySelector('.pr-acc__prayer-toggle');
        var pPanel  = pToggle ? document.getElementById(pToggle.getAttribute('aria-controls')) : null;
        setItemState(prayer, pToggle, pPanel, willOpen);
      });
    });
  });

  // Prayer toggles — independent within a category
  document.querySelectorAll('.pr-acc__prayer-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      var prayer = toggle.closest('.pr-acc__prayer');
      if (!prayer) return;
      var panel  = document.getElementById(toggle.getAttribute('aria-controls'));
      var willOpen = !prayer.classList.contains('is-open');
      setItemState(prayer, toggle, panel, willOpen);
    });
  });

  // Showcase nav tiles — open the target category, then let the global
  // smooth-scroll handler scroll to its anchor.
  document.querySelectorAll('.pr-acc__nav-tile').forEach(function (tile) {
    tile.addEventListener('click', function () {
      var href = tile.getAttribute('href') || '';
      if (href.charAt(0) !== '#') return;
      var cat = document.getElementById(href.slice(1));
      if (!cat) return;
      if (!cat.classList.contains('is-open')) {
        var catToggle = cat.querySelector('.pr-acc__cat-toggle');
        if (catToggle) catToggle.click();
      }
    });
  });
})();

// ── Prayer Showcase (Inline Expanding Grid) ───────────────────────────────
// Click a tile → its panel moves to the end of the row containing that tile
// and expands inline (iOS Photos-style). One panel open at a time per section.
(function () {
  function initRoot(root) {
    var grid = root.querySelector('.pr-show__grid');
    if (!grid) return;
    var tiles = grid.querySelectorAll('.pr-show__tile');
    var panels = grid.querySelectorAll('.pr-show__panel');
    if (!tiles.length || !panels.length) return;

    // Remember each panel's original DOM position so we can park it
    // back at the end of the grid when closed.
    panels.forEach(function (panel) { grid.appendChild(panel); });

    var activeKey = null;
    var activeTile = null;

    function findPanel(key) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-pr-key') === key) return panels[i];
      }
      return null;
    }

    function rowSiblings(tile) {
      var top = tile.getBoundingClientRect().top;
      var out = [];
      for (var i = 0; i < tiles.length; i++) {
        if (Math.abs(tiles[i].getBoundingClientRect().top - top) < 2) out.push(tiles[i]);
      }
      return out;
    }

    function resetPrayersIn(panel) {
      if (!panel) return;
      panel.querySelectorAll('.pr-show__prayer.is-open').forEach(function (pr) {
        pr.classList.remove('is-open');
        var btn = pr.querySelector('.pr-show__prayer-toggle');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      });
    }

    function closeActive(skipPark) {
      if (!activeKey) return;
      var panel = findPanel(activeKey);
      if (panel) {
        panel.classList.remove('is-open');
        // Park panel back at the end of the grid after the transition.
        // skipPark is used when we're immediately reopening another panel.
        if (!skipPark) {
          setTimeout(function () {
            if (!panel.classList.contains('is-open')) {
              grid.appendChild(panel);
              panel.hidden = true;
            }
          }, 520);
        }
        resetPrayersIn(panel);
      }
      if (activeTile) {
        activeTile.setAttribute('aria-expanded', 'false');
        clearActiveStyle(activeTile);
      }
      activeKey = null;
      activeTile = null;
    }

    // Visual feedback only — no transform. The tile must NOT move on
    // activation, otherwise the act of clicking visibly shifts other
    // tiles in the same row relative to the lifted one.
    function setActiveStyle(tile) {
      tile.style.setProperty('border-color', '#00BEDD', 'important');
      tile.style.setProperty('background-color', 'rgba(0, 190, 221, 0.08)', 'important');
      tile.style.setProperty('box-shadow',
        '0 18px 40px -16px rgba(0, 190, 221, 0.6), 0 6px 14px -6px rgba(10, 10, 15, 0.22)',
        'important');
      tile.style.setProperty('z-index', '2', 'important');
      tile.style.setProperty('transition',
        'border-color 240ms ease-out 0ms, ' +
        'box-shadow 320ms ease-out 0ms, ' +
        'background-color 240ms ease-out 0ms',
        'important');
    }
    function clearActiveStyle(tile) {
      tile.style.removeProperty('border-color');
      tile.style.removeProperty('background-color');
      tile.style.removeProperty('box-shadow');
      tile.style.removeProperty('z-index');
      setTimeout(function () { tile.style.removeProperty('transition'); }, 320);
    }

    function positionTail(tile, panel) {
      var tRect = tile.getBoundingClientRect();
      var pRect = panel.getBoundingClientRect();
      var x = tRect.left + tRect.width / 2 - pRect.left;
      panel.style.setProperty('--pr-tail-x', x + 'px');
    }

    function openFor(tile) {
      var key = tile.getAttribute('data-pr-key');
      var panel = findPanel(key);
      if (!panel) return;

      // Find the last tile in the same visual row as the clicked tile,
      // then jump out to its <li> wrapper (the actual grid child).
      var siblings = rowSiblings(tile);
      var lastTile = siblings[siblings.length - 1];
      var lastWrap = lastTile.closest('.pr-show__tile-wrap') || lastTile;

      // Move the panel to immediately follow that LI in the grid.
      grid.insertBefore(panel, lastWrap.nextElementSibling);
      panel.hidden = false;

      // Place the notch under the active tile before the panel fades in.
      positionTail(tile, panel);

      // Make sure no stale prayer item is left open from a previous visit.
      resetPrayersIn(panel);

      // Auto-open the first prayer so the user lands on real content
      // instead of an empty list of titles.
      var firstPrayer = panel.querySelector('.pr-show__prayer');
      var firstToggle = firstPrayer && firstPrayer.querySelector('.pr-show__prayer-toggle');

      // Trigger the open transitions on the next frame so the
      // grid-template-rows changes actually animate.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
          if (firstPrayer) {
            firstPrayer.classList.add('is-open');
            if (firstToggle) firstToggle.setAttribute('aria-expanded', 'true');
          }
          // Scroll the active TILE (not the panel) to the top of the
          // viewport so the athlete sees the button they just clicked
          // and the dropdown opening beneath it.
          var scrollTarget = tile.closest('.pr-show__tile-wrap') || tile;
          scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      });

      tile.setAttribute('aria-expanded', 'true');
      setActiveStyle(tile);
      activeKey = key;
      activeTile = tile;
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var key = tile.getAttribute('data-pr-key');
        if (activeKey === key) {
          closeActive();
          return;
        }
        // Switching from another open panel: snap the old one closed
        // immediately (no close animation) so the layout settles before
        // openFor's scrollIntoView calculates the new panel's position.
        if (activeKey) {
          var current = findPanel(activeKey);
          if (current) {
            current.classList.remove('is-open');
            resetPrayersIn(current);
            grid.appendChild(current);
            current.hidden = true;
          }
          if (activeTile) {
            activeTile.setAttribute('aria-expanded', 'false');
            clearActiveStyle(activeTile);
          }
          activeKey = null;
          activeTile = null;
        }
        openFor(tile);
      });
    });

    // Close buttons inside each panel (header X and the footer Close link)
    root.querySelectorAll('[data-pr-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tileToRefocus = activeTile;
        closeActive();
        if (tileToRefocus) tileToRefocus.focus({ preventScroll: false });
      });
    });

    // Prayer item toggles within the showcase
    root.querySelectorAll('.pr-show__prayer-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var prayer = toggle.closest('.pr-show__prayer');
        if (!prayer) return;
        var willOpen = !prayer.classList.contains('is-open');
        prayer.classList.toggle('is-open', willOpen);
        toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });

    // Reposition the open panel if column count changes on resize.
    var resizeTimer;
    window.addEventListener('resize', function () {
      if (!activeKey || !activeTile) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!activeKey || !activeTile) return;
        var panel = findPanel(activeKey);
        if (!panel) return;
        var siblings = rowSiblings(activeTile);
        var lastTile = siblings[siblings.length - 1];
        var lastWrap = lastTile.closest('.pr-show__tile-wrap') || lastTile;
        if (panel.previousElementSibling !== lastWrap) {
          grid.insertBefore(panel, lastWrap.nextElementSibling);
        }
        positionTail(activeTile, panel);
      }, 120);
    });
  }

  document.querySelectorAll('[data-pr-show]').forEach(initRoot);
})();

// ── Saints Showcase (Inline Expanding Grid) ───────────────────────────────
// Same iOS Photos-style pattern as the prayer showcase, applied to saint
// tiles on the Inspiration from the Saints page.
(function () {
  function initRoot(root) {
    var grid = root.querySelector('.sf-saint-show__grid');
    if (!grid) return;
    var tiles = grid.querySelectorAll('.sf-saint-show__tile');
    var panels = grid.querySelectorAll('.sf-saint-show__panel');
    if (!tiles.length || !panels.length) return;

    // Sort tile wraps alphabetically by their data-sf-saint-sort key
    // (falls back to label text). Editor-order in admin is preserved as
    // the data structure; display order is alphabetical.
    var wrapList = [];
    tiles.forEach(function (t) {
      var w = t.closest('.sf-saint-show__tile-wrap');
      if (w && wrapList.indexOf(w) === -1) wrapList.push(w);
    });
    wrapList.sort(function (a, b) {
      var at = a.querySelector('.sf-saint-show__tile');
      var bt = b.querySelector('.sf-saint-show__tile');
      var av = (at && at.getAttribute('data-sf-saint-sort')) || (at && at.textContent) || '';
      var bv = (bt && bt.getAttribute('data-sf-saint-sort')) || (bt && bt.textContent) || '';
      return av.localeCompare(bv);
    });
    wrapList.forEach(function (w) { grid.appendChild(w); });
    // Re-query tiles in their new order
    tiles = grid.querySelectorAll('.sf-saint-show__tile');

    panels.forEach(function (panel) { grid.appendChild(panel); });

    var activeKey = null;
    var activeTile = null;

    function findPanel(key) {
      for (var i = 0; i < panels.length; i++) {
        if (panels[i].getAttribute('data-sf-saint-key') === key) return panels[i];
      }
      return null;
    }

    function rowSiblings(tile) {
      var top = tile.getBoundingClientRect().top;
      var out = [];
      for (var i = 0; i < tiles.length; i++) {
        if (Math.abs(tiles[i].getBoundingClientRect().top - top) < 2) out.push(tiles[i]);
      }
      return out;
    }

    function clearActiveStyle(tile) {
      tile.style.removeProperty('border-color');
      tile.style.removeProperty('background-color');
      tile.style.removeProperty('box-shadow');
      tile.style.removeProperty('z-index');
      setTimeout(function () { tile.style.removeProperty('transition'); }, 320);
    }

    // Visual feedback only — no transform. The tile must NOT move on
    // activation, otherwise the act of clicking visibly shifts other
    // tiles in the same row relative to the lifted one.
    function setActiveStyle(tile) {
      tile.style.setProperty('border-color', '#00BEDD', 'important');
      tile.style.setProperty('background-color', 'rgba(0, 190, 221, 0.08)', 'important');
      tile.style.setProperty('box-shadow',
        '0 18px 40px -16px rgba(0, 190, 221, 0.6), 0 6px 14px -6px rgba(10, 10, 15, 0.22)',
        'important');
      tile.style.setProperty('z-index', '2', 'important');
      tile.style.setProperty('transition',
        'border-color 240ms ease-out 0ms, ' +
        'box-shadow 320ms ease-out 0ms, ' +
        'background-color 240ms ease-out 0ms',
        'important');
    }

    function closeActive(skipPark) {
      if (!activeKey) return;
      var panel = findPanel(activeKey);
      if (panel) {
        panel.classList.remove('is-open');
        if (!skipPark) {
          setTimeout(function () {
            if (!panel.classList.contains('is-open')) {
              grid.appendChild(panel);
              panel.hidden = true;
            }
          }, 520);
        }
      }
      if (activeTile) {
        activeTile.setAttribute('aria-expanded', 'false');
        clearActiveStyle(activeTile);
      }
      activeKey = null;
      activeTile = null;
    }

    function positionTail(tile, panel) {
      var tRect = tile.getBoundingClientRect();
      var pRect = panel.getBoundingClientRect();
      var x = tRect.left + tRect.width / 2 - pRect.left;
      panel.style.setProperty('--sf-tail-x', x + 'px');
    }

    function openFor(tile) {
      var key = tile.getAttribute('data-sf-saint-key');
      var panel = findPanel(key);
      if (!panel) return;

      var siblings = rowSiblings(tile);
      var lastTile = siblings[siblings.length - 1];
      var lastWrap = lastTile.closest('.sf-saint-show__tile-wrap') || lastTile;

      grid.insertBefore(panel, lastWrap.nextElementSibling);
      panel.hidden = false;

      // Set tail before animating so the notch is in place when opacity fades in.
      positionTail(tile, panel);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.classList.add('is-open');
          // Mobile: scroll the active tile wrap to top — panel appears right below it.
          // Desktop: panel is below an entire 3-col row, so scroll the PANEL near the top
          // with a small offset so the active tile's caption (name + role) is still
          // visible above. User stays oriented on which saint they opened.
          var isDesktop = window.matchMedia('(min-width: 768px)').matches;
          if (isDesktop) {
            var panelRect = panel.getBoundingClientRect();
            var offset = 100; // px of tile row peeking above the panel
            var y = window.scrollY + panelRect.top - offset;
            window.scrollTo({ top: y, behavior: 'smooth' });
          } else {
            var scrollTarget = tile.closest('.sf-saint-show__tile-wrap') || tile;
            scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });

      tile.setAttribute('aria-expanded', 'true');
      setActiveStyle(tile);
      activeKey = key;
      activeTile = tile;
    }

    tiles.forEach(function (tile) {
      tile.addEventListener('click', function () {
        var key = tile.getAttribute('data-sf-saint-key');
        if (activeKey === key) {
          closeActive();
          return;
        }
        // Switching from another open panel: snap the old one closed
        // immediately (no close animation) so the layout settles before
        // openFor's scrollIntoView calculates the new panel's position.
        // Otherwise the closing panel's collapsing height shifts the
        // new panel upward mid-scroll and the page lands above the
        // dropdown's actual top.
        if (activeKey) {
          var current = findPanel(activeKey);
          if (current) {
            current.classList.remove('is-open');
            grid.appendChild(current);
            current.hidden = true;
          }
          if (activeTile) {
            activeTile.setAttribute('aria-expanded', 'false');
            clearActiveStyle(activeTile);
          }
          activeKey = null;
          activeTile = null;
        }
        openFor(tile);
      });
    });

    root.querySelectorAll('[data-sf-saint-close]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tileToRefocus = activeTile;
        closeActive();
        if (tileToRefocus) tileToRefocus.focus({ preventScroll: false });
      });
    });

    // View Next — opens the next saint in alphabetical DOM order (wraps to
    // first after the last). The existing tile click handler does the
    // close-then-open switch, so we just dispatch a click on the next tile.
    root.querySelectorAll('[data-sf-saint-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!activeTile) return;
        var currentWrap = activeTile.closest('.sf-saint-show__tile-wrap');
        if (!currentWrap) return;
        var allWraps = Array.prototype.slice.call(
          grid.querySelectorAll('.sf-saint-show__tile-wrap')
        );
        var idx = allWraps.indexOf(currentWrap);
        if (idx === -1) return;
        var nextIdx = (idx + 1) % allWraps.length;
        var nextTile = allWraps[nextIdx].querySelector('.sf-saint-show__tile');
        if (!nextTile) return;
        // openFor (triggered by the tile click below) handles the
        // scroll-to-panel for every open, so no extra scroll needed here.
        nextTile.click();
      });
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      if (!activeKey || !activeTile) return;
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (!activeKey || !activeTile) return;
        var panel = findPanel(activeKey);
        if (!panel) return;
        var siblings = rowSiblings(activeTile);
        var lastTile = siblings[siblings.length - 1];
        var lastWrap = lastTile.closest('.sf-saint-show__tile-wrap') || lastTile;
        if (panel.previousElementSibling !== lastWrap) {
          grid.insertBefore(panel, lastWrap.nextElementSibling);
        }
        positionTail(activeTile, panel);
      }, 120);
    });
  }

  document.querySelectorAll('[data-sf-saint-show]').forEach(initRoot);
})();

// ── Smooth Scroll for Anchor Links ────────────────────────────────────────
(function () {
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var targetId = this.getAttribute('href').slice(1);
      if (!targetId) return;
      var target = document.getElementById(targetId);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();

// ── Podcast Episode Search (static block list only) ──────────────────────
// RSS-driven sections handle their own search inside the RSS module so that
// pagination state and dynamically rendered cards stay in sync.
(function () {
  document.querySelectorAll('[data-pod-eps]').forEach(function (root) {
    if (root.hasAttribute('data-pod-rss-url')) return;
    var input = root.querySelector('[data-pod-search]');
    if (!input) return;
    var empty = root.querySelector('[data-pod-noresults]');

    function filter() {
      var q = input.value.trim().toLowerCase();
      var cards = root.querySelectorAll('[data-pod-card]');
      var visible = 0;
      cards.forEach(function (card) {
        var text = card.getAttribute('data-search-text') || '';
        var match = q === '' || text.indexOf(q) !== -1;
        card.hidden = !match;
        if (match) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    }

    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
  });
})();

// ── Podcast Episodes from RSS (raw XML via CORS-enabled proxy) ────────────
(function () {
  var roots = document.querySelectorAll('[data-pod-eps][data-pod-rss-url]');
  if (!roots.length) return;

  var ITUNES_NS = 'http://www.itunes.com/dtds/podcast-1.0.dtd';
  var INITIAL_VISIBLE = 10;

  function escapeHTML(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function stripHTML(html) {
    var d = document.createElement('div');
    d.innerHTML = String(html || '');
    return (d.textContent || d.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function formatDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function formatDuration(s) {
    if (!s) return '';
    s = String(s).trim();
    var h = 0, m = 0;
    if (s.indexOf(':') !== -1) {
      var parts = s.split(':').map(function (p) { return parseInt(p, 10) || 0; });
      if (parts.length === 3) { h = parts[0]; m = parts[1]; }
      else if (parts.length === 2) { m = parts[0]; }
    } else {
      var total = parseInt(s, 10);
      if (!total || isNaN(total)) return '';
      h = Math.floor(total / 3600);
      m = Math.round((total - h * 3600) / 60);
    }
    if (h && m) return h + ' hr ' + m + ' min';
    if (h) return h + ' hr';
    if (m) return m + ' min';
    return '';
  }

  function getChild(item, tag, ns) {
    if (ns) {
      var byNs = item.getElementsByTagNameNS(ns, tag);
      if (byNs.length) return byNs[0];
    }
    var byTag = item.getElementsByTagName(tag);
    return byTag.length ? byTag[0] : null;
  }

  function getText(item, tag, ns) {
    var el = getChild(item, tag, ns);
    return el ? (el.textContent || '').trim() : '';
  }

  function parseFeed(xmlText) {
    var doc = new DOMParser().parseFromString(xmlText, 'application/xml');
    if (doc.querySelector('parsererror')) return [];
    var items = doc.getElementsByTagName('item');
    var out = [];
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var epType = getText(it, 'episodeType', ITUNES_NS).toLowerCase();
      if (epType && epType !== 'full') continue;
      var enclosure = it.getElementsByTagName('enclosure')[0];
      out.push({
        title: getText(it, 'title'),
        pubDate: getText(it, 'pubDate'),
        description: getText(it, 'description'),
        duration: getText(it, 'duration', ITUNES_NS),
        audio: enclosure ? enclosure.getAttribute('url') : '',
        link: getText(it, 'link'),
      });
    }
    return out;
  }

  function buildCard(ep, episodeNumber) {
    var dateStr = formatDate(ep.pubDate);
    var dur = formatDuration(ep.duration);
    var title = escapeHTML(ep.title || '');
    var descText = stripHTML(ep.description || '');
    var searchText = (ep.title + ' ' + descText).toLowerCase().trim().replace(/[<>"']/g, '');

    var html = '<li class="pod-eps__card pod-eps__card--compact" data-pod-card data-search-text="' + escapeHTML(searchText) + '">';
    html += '<div class="pod-eps__meta">';
    if (episodeNumber) html += '<span class="pod-eps__num">EP ' + escapeHTML(String(episodeNumber).padStart(2, '0')) + '</span>';
    if (dateStr) html += '<span class="pod-eps__date">' + escapeHTML(dateStr) + '</span>';
    if (dur) html += '<span class="pod-eps__dur">' + escapeHTML(dur) + '</span>';
    html += '</div>';
    if (title) html += '<h3 class="pod-eps__ep-title">' + title + '</h3>';
    if (descText) {
      var isLong = descText.length > 180;
      var descClass = 'pod-eps__ep-desc' + (isLong ? ' pod-eps__ep-desc--clamp pod-eps__ep-desc--tight' : '');
      html += '<p class="' + descClass + '">' + escapeHTML(descText) + '</p>';
      if (isLong) {
        html += '<button type="button" class="pod-eps__ep-more" data-pod-more aria-expanded="false">Read more</button>';
      }
    }
    if (ep.audio) {
      html += '<div class="pod-eps__player">' +
        '<audio controls preload="none" src="' + escapeHTML(ep.audio) + '">' +
        'Your browser does not support the audio element. ' +
        '<a href="' + escapeHTML(ep.audio) + '">Download the episode</a>.' +
        '</audio></div>';
    }
    html += '</li>';
    return html;
  }

  function render(root) {
    var url = root.getAttribute('data-pod-rss-url');
    var listEl = root.querySelector('[data-pod-rss-list]');
    var statusEl = root.querySelector('[data-pod-rss-status]');
    var fallbackEl = root.querySelector('[data-pod-rss-fallback]');
    var searchWrap = root.querySelector('[data-pod-search-wrap]');
    var searchInput = root.querySelector('[data-pod-search]');
    var noResultsEl = root.querySelector('[data-pod-noresults]');
    if (!listEl || !url) return;

    var controller = ('AbortController' in window) ? new AbortController() : null;
    var timeoutId = setTimeout(function () { if (controller) controller.abort(); }, 8000);

    fetch(url, controller ? { signal: controller.signal } : undefined)
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (xml) {
        clearTimeout(timeoutId);
        var episodes = parseFeed(xml);
        if (!episodes.length) throw new Error('No items');
        var total = episodes.length;
        listEl.innerHTML = episodes.map(function (ep, idx) {
          return buildCard(ep, total - idx);
        }).join('');
        listEl.hidden = false;
        if (statusEl) statusEl.hidden = true;
        if (searchWrap) searchWrap.hidden = false;
        if (fallbackEl) fallbackEl.hidden = true;

        wirePagination(root, listEl, total);
        wireSearch(root, listEl, searchInput, noResultsEl);
        wireReadMore(listEl);
      })
      .catch(function () {
        clearTimeout(timeoutId);
        listEl.hidden = true;
        if (statusEl) statusEl.hidden = true;
        if (searchWrap) searchWrap.hidden = true;
        if (fallbackEl) fallbackEl.hidden = false;
      });
  }

  function wireReadMore(listEl) {
    listEl.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-pod-more]');
      if (!btn) return;
      var desc = btn.previousElementSibling;
      if (!desc || !desc.classList.contains('pod-eps__ep-desc')) return;
      var nowClamped = desc.classList.toggle('pod-eps__ep-desc--clamp');
      btn.textContent = nowClamped ? 'Read more' : 'Read less';
      btn.setAttribute('aria-expanded', nowClamped ? 'false' : 'true');
    });
  }

  function wirePagination(root, listEl, total) {
    var perPage = INITIAL_VISIBLE;
    var totalPages = Math.ceil(total / perPage);
    var cards = listEl.querySelectorAll('[data-pod-card]');

    for (var i = 0; i < cards.length; i++) {
      cards[i].setAttribute('data-pod-page', Math.floor(i / perPage) + 1);
    }

    var existing = root.querySelector('[data-pod-rss-pager]');
    if (existing) existing.remove();

    if (totalPages <= 1) {
      cards.forEach(function (c) { c.hidden = false; });
      return;
    }

    var pager = document.createElement('nav');
    pager.className = 'pod-eps__pager';
    pager.setAttribute('data-pod-rss-pager', '');
    pager.setAttribute('aria-label', 'Episode pages');

    var prev = document.createElement('button');
    prev.type = 'button';
    prev.className = 'pod-eps__pager-btn pod-eps__pager-btn--nav';
    prev.textContent = '‹ Prev';
    prev.setAttribute('aria-label', 'Previous page');
    pager.appendChild(prev);

    var numBtns = [];
    for (var p = 1; p <= totalPages; p++) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'pod-eps__pager-btn pod-eps__pager-num';
      b.textContent = String(p);
      b.setAttribute('aria-label', 'Page ' + p);
      pager.appendChild(b);
      numBtns.push(b);
    }

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'pod-eps__pager-btn pod-eps__pager-btn--nav';
    next.textContent = 'Next ›';
    next.setAttribute('aria-label', 'Next page');
    pager.appendChild(next);

    listEl.parentNode.insertBefore(pager, listEl.nextSibling);

    var currentPage = 1;

    function setPage(p, scroll) {
      if (p < 1 || p > totalPages) return;
      currentPage = p;
      cards.forEach(function (c) {
        var cp = parseInt(c.getAttribute('data-pod-page'), 10);
        c.hidden = cp !== p;
      });
      numBtns.forEach(function (btn, idx) {
        var active = idx + 1 === p;
        btn.classList.toggle('is-active', active);
        if (active) btn.setAttribute('aria-current', 'page');
        else btn.removeAttribute('aria-current');
      });
      prev.disabled = p === 1;
      next.disabled = p === totalPages;
      if (scroll) {
        var rect = listEl.getBoundingClientRect();
        if (rect.top < 0) window.scrollTo({ top: window.scrollY + rect.top - 20, behavior: 'smooth' });
      }
    }

    numBtns.forEach(function (btn, idx) {
      btn.addEventListener('click', function () { setPage(idx + 1, true); });
    });
    prev.addEventListener('click', function () { setPage(currentPage - 1, true); });
    next.addEventListener('click', function () { setPage(currentPage + 1, true); });

    setPage(1, false);

    root._podPager = pager;
    root._podSetPage = setPage;
  }

  function wireSearch(root, listEl, input, noResultsEl) {
    if (!input) return;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var cards = listEl.querySelectorAll('[data-pod-card]');
      var pager = root._podPager;

      if (q !== '') {
        if (pager) pager.hidden = true;
        var visible = 0;
        cards.forEach(function (card) {
          var text = card.getAttribute('data-search-text') || '';
          var match = text.indexOf(q) !== -1;
          card.hidden = !match;
          if (match) visible++;
        });
        if (noResultsEl) noResultsEl.hidden = visible !== 0;
      } else {
        if (pager) pager.hidden = false;
        if (noResultsEl) noResultsEl.hidden = true;
        if (typeof root._podSetPage === 'function') root._podSetPage(1, false);
        else cards.forEach(function (c) { c.hidden = false; });
      }
    });
  }

  roots.forEach(render);
})();

// ── Athlete Spotlight Carousel ─────────────────────────────────────────────
(function () {
  var carousels = document.querySelectorAll('[data-sf-spotlight]');
  if (!carousels.length) return;

  carousels.forEach(function (root) {
    var track = root.querySelector('[data-sf-spotlight-track]');
    var slides = root.querySelectorAll('[data-sf-spotlight-slide]');
    var prevBtn = root.querySelector('[data-sf-spotlight-prev]');
    var nextBtn = root.querySelector('[data-sf-spotlight-next]');
    var dots = root.querySelectorAll('[data-sf-spotlight-dot]');

    if (!track || slides.length <= 1) return;

    var current = 0;
    var total = slides.length;

    function goTo(i) {
      if (i < 0) i = total - 1;
      if (i >= total) i = 0;
      current = i;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, idx) {
        d.classList.toggle('is-active', idx === i);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-sf-spotlight-dot'), 10));
      });
    });

    // Touch / swipe
    var startX = 0;
    var deltaX = 0;
    var dragging = false;

    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      deltaX = 0;
      dragging = true;
    }, { passive: true });

    track.addEventListener('touchmove', function (e) {
      if (!dragging) return;
      deltaX = e.touches[0].clientX - startX;
    }, { passive: true });

    track.addEventListener('touchend', function () {
      if (!dragging) return;
      dragging = false;
      if (Math.abs(deltaX) > 50) {
        goTo(current + (deltaX < 0 ? 1 : -1));
      }
    });

    // Keyboard arrows when carousel is focused
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); }
    });
  });
})();
